export default "__VITE_ASSET__DZMV51eX__"